import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'seamless-immutable';

export const Installment = ({ payment }) => {
  const type = getIn(payment, ['paymentDisplay']);

  if (type === 'no boleto' || type === 'com pix') {
    return type;
  }

  const installmentDisplay = getIn(payment, ['installmentDisplay']);
  const cashbackValue = getIn(payment, ['cashback', 'value']);

  return (
    <>
      {installmentDisplay} no&nbsp;
      <strong>
        cartão {type} {cashbackValue ? 'com Ame' : ''}
      </strong>
    </>
  );
};

Installment.proptypes = {
  payment: PropTypes.shape({
    paymentDisplay: PropTypes.string,
    installmentDisplay: PropTypes.string,
  }),
};
